import React, { useState } from 'react';
import "./navbar.css";
import { RiMenu3Line, RiCloseLine } from "react-icons/ri";

const Menu = () => (
  <>
    <p><a href="#contact">Home</a></p>
    <p><a href="#home">About</a></p>
    <p><a href="#services">Projects</a></p>
  </>
)

const Navbar = () => {
  const [toggleMenu, setToggleMenu] = useState(false);

  return (
    <div className='container'>
      <div className="nav-wrapper">
        <h2 className='logo scale-up-center'>Rocky Coast Labs</h2>
        <div className="link-wrapper scale-up-center">
          <Menu />
        </div>

        <div className="nav-menu">
          {toggleMenu
            ? <RiCloseLine color="#DDE9E5" size={27} onClick={() => setToggleMenu(false)} />
            : <RiMenu3Line color="#DDE9E5" size={27} onClick={() => setToggleMenu(true)} />
          }
          {toggleMenu && (
            <div className="nav-menu-container scale-up-center">
              <Menu />
            </div>
          )}
        </div>
      </div>
    </div>
  )
};

export default Navbar
